import React from 'react';
import MetricsTable, { Metric } from './MetricsTable';
import type { CategorizedMetrics } from './types/metricTypes';

interface MetricsTablesSectionProps {
  categorizedMetrics: CategorizedMetrics;
  onDeleteMetric: (metric: Metric) => void;
  onEditMetric: (metric: Metric) => void;
}

const MetricsTablesSection: React.FC<MetricsTablesSectionProps> = ({
  categorizedMetrics,
  onDeleteMetric,
  onEditMetric
}) => {
  return (
    <>
      <MetricsTable
        metrics={categorizedMetrics.usageLicenseCreditMetrics as any}
        title="Modality Metrics"
        description="Metrics based on usage, licenses, or credits"
        onDeleteMetric={onDeleteMetric}
        onEditMetric={onEditMetric}
      />
      {categorizedMetrics.thresholdFlatMetrics.length > 0 && (
        <div className="mt-8 mb-4 border-t pt-6">
          <MetricsTable
            metrics={categorizedMetrics.thresholdFlatMetrics as any}
            title="Threshold Based Metrics"
            description="Metrics based on thresholds or tiers - commonly used for usage-based pricing with bracket or volume discounts"
            onDeleteMetric={onDeleteMetric}
            onEditMetric={onEditMetric}
          />
        </div>
      )}
      <MetricsTable
        metrics={categorizedMetrics.otherMetrics as any}
        title="Other Metrics"
        description="Metrics with unknown or other modality types"
        onDeleteMetric={onDeleteMetric}
        onEditMetric={onEditMetric}
      />
    </>
  );
};

export default MetricsTablesSection;
